import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { ruleStatusMap } from '@/constants.js';
const SearchGroup = (props) => {
  const [form] = Form.useForm();
  const { addRuleChange } = props || {};
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    props.handleSearch(values);
  };

  const onReset = () => {
    form.resetFields();
    // props.handleSearch({});
  };
  const addRule = () => {
    addRuleChange && addRuleChange();
  };
  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 会员号 */}
      {/* <Col span={8}> */}
      <div className={styles.input_contain}>
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="269px"
          labelVal="规则包名称"
          placeVal="请输入规则包名"
          name="ruleBlockName"
          allowClear={true}
          // icon={}
        />
        {/* 性别 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="269px"
          labelVal="规则包状态"
          placeVal="请选择"
          name="status"
          allowClear={true}
          option={toOption(ruleStatusMap)}
          // icon={}
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML
          size="large"
          value="查询"
          htmlType="submit"
          // width="106px"
          // height="46px"
          fontsize="16px"
        />
        <ButtonML
          size="large"
          value="重置"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={onReset}
        />
        <ButtonML
          size="large"
          value="新增规则包"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={addRule}
        />
      </div>
    </Form>
  );
};

export default SearchGroup;
